import { Icon, TextPassage } from '@petsmart-ui/sparky';
import Link from 'next/link';
import type { StandardTileProps } from '../types';

import './StandardTiles.scss';

export default function StandardTile(linkAction: StandardTileProps) {
    const flatLink = {
        actionText: linkAction.actionText,
        webUrl: linkAction.link.webUrl,
        ...('iconName' in linkAction.link && {
            iconName: linkAction.link.iconName,
        }),
    };

    return (
        <Link
            href={flatLink?.webUrl}
            className="tiles-4--standard"
            data-testid="tile-standard"
            prefetch={false} // https://petsmart.atlassian.net/browse/HCP-594
        >
            <Icon size="md" name={flatLink?.iconName} />
            <TextPassage>{flatLink.actionText}</TextPassage>
        </Link>
    );
}
